import React, {useState, useEffect} from 'react';
import post from '../utils/post.js';
import {APP_VERSION} from '../utils/appVersion.js';
import AppHeader from '../components/AppHeader.js';
import Search from '../components/Search.js';

export default function MyPayment({usrInfo, timerCnt}) {
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState([]);
	const [searchValue, setSearchValue] = useState('');
	const [offset, setOffset] = useState(0);
	const [loadedCnt, setLoadedCnt] = useState(0);

	useEffect(() => {
		let search = '';

		if (typeof window.location.pathname.split('/')[2] != 'undefined') {
			search = decodeURI(window.location.pathname.split('/')[2]);
			setSearchValue(search);
		}

		getData(search, offset);

		if (search !== '') {
			window.history.pushState({}, document.title, '/userlog');
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const loadNext = () => {
		setOffset((prevOffset) => {
			let newOffset = prevOffset + usrInfo.LIST_ROWS;
			getData(searchValue, prevOffset + usrInfo.LIST_ROWS);
			return newOffset;
		});
	};

	const onChangeSearch = (value) => {
		setSearchValue(value);
		setOffset(0);
		getData(value, 0);
	};

	const getData = (search, offset) => {
		setLoading(true);

		post('getListMyPayment', {search: search, offset: offset})
			.then((res) => {
				if (offset === 0) {
					setData(res.data);
				} else {
					setData((prevRows) => {
						const updatedRows = [...prevRows, ...res.data];
						return updatedRows;
					});
				}

				setLoadedCnt(res.data.length);

				setLoading(false);
			})
			.catch((error) => {
				console.error(error);
				setLoading(false);
			});
	};

	const handleOpenPdf = async (url) => {
		setLoading(true);

		try {
			const res = await fetch(url, {
				headers: {Authorization: `Bearer ${usrInfo.token}`, 'X-App-Version': APP_VERSION}
			});

			if (!res.ok) {
				throw new Error(`PDF generation failed with status ${res.status}`);
			}

			const blob = await res.blob();
			const pdfUrl = URL.createObjectURL(blob);
			window.open(pdfUrl, '_blank');
			setTimeout(() => URL.revokeObjectURL(pdfUrl), 1000);
		} catch (error) {
			console.error(error);
		} finally {
			setLoading(false);
		}
	};

	const list = data?.map((line, index) => {
		return (
			<article className="mypayment-page__card" key={index}>
				<div className="mypayment-page__card-main">
					<div className="mypayment-page__card-meta">
						<div className="mypayment-page__card-headline">
							<div className="mypayment-page__card-date">{line.PAYMENTDTS}</div>
						</div>
					</div>
					<div className="mypayment-page__card-side">
						<div className="mypayment-page__card-amount">{line.AMOUNTS}</div>
						<button
							type="button"
							className="mypayment-page__pdf-button"
							onClick={() => handleOpenPdf(`/rest/myPaymentPdf?ID=${line.ID}`)}
						>
							<img className="icon1 pdf" alt="" />
							<span>Doklad</span>
						</button>
					</div>
				</div>
				{line.NOTE !== '' ? <div className="mypayment-page__card-note">{line.NOTE}</div> : ''}
			</article>
		);
	});

	return (
		<>
			<div className="page_main">
				<AppHeader usrInfo={usrInfo} timerCnt={timerCnt} loading={loading} />
				<Search showSearch searchValue={searchValue} onChangeSearch={(e) => onChangeSearch(e)}></Search>

				<div className={`page mypayment-page${usrInfo.sysAdmin === 1 || usrInfo.manager === 1 || usrInfo.instructor === 1 ? ' more' : ''}`}>
					<div className="mypayment-page__list">
						{list.length > 0 ? list : <div className="mypayment-page__empty">Zatím nemáš žádné platby.</div>}
					</div>

					<div className="mypayment-page__load-more">
						{parseInt(loadedCnt, 10) === parseInt(usrInfo.LIST_ROWS, 10) ? (
							<button className="button small loadNext mypayment-page__button" onClick={() => loadNext()}>
								Načíst další
							</button>
						) : (
							<span className="fnt_12 loadNext mypayment-page__load-all">Byly načteny všechny záznamy</span>
						)}
					</div>
				</div>
			</div>
		</>
	);
}
